import { z } from 'zod';
export const verifyMultipleAccountLicensesFunctionDef = {
    name: 'verifyMultipleAccountLicenses',
    requestSchema: z.object({}),
    responseSchema: z.void(),
};
const licenseCheckAnalyticsCountSchema = z.object({
    notVerified: z.number(),
    verified: z.number(),
    failed: z.number(),
    expired: z.number(),
});
export const licenseCheckAnalyticsSchema = z.object({
    manual: licenseCheckAnalyticsCountSchema.merge(z.object({
        verifiedExpiring: z.number(),
    })),
    automatic: licenseCheckAnalyticsCountSchema,
});
export const getLicenseCheckLatestStatusAnalyticsFunctionDef = {
    name: 'getLicenseCheckLatestStatusAnalytics',
    requestSchema: z.object({}),
    responseSchema: licenseCheckAnalyticsSchema,
};
export const baseRequestLicenseCheckParamsSchema = z.object({
    requestedBy: z.string().min(1),
});
export const requestPersonLicenseCheckParamsSchema = baseRequestLicenseCheckParamsSchema.merge(z.object({
    personId: z.string().min(1),
}));
export const requestLicenseCheckFunctionDef = {
    name: 'requestLicenseCheck',
    requestSchema: requestPersonLicenseCheckParamsSchema,
    responseSchema: z.void(),
};
export const sendCredentialVerificationNotificationFunctionDef = {
    name: 'sendCredentialVerificationNotification',
    requestSchema: z.object({}),
    responseSchema: z.void(),
};
